<template>
  <div class="component-container">
    <h3>3PNG Forces and Interactions (Second Edition) - Downloads and Resources</h3>
    <div class="back-button-wrapper">
      <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
    </div>
    <div class="presentations">
      <h4>Teacher Resources</h4>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2F3PNG-2E_Activities_1-6_08212024.zip?alt=media&token=8edd8e7c-4e71-47d8-ba63-2adc559fe527" target="_blank">Teacher Presentations: Activities 1 - 6</a> - Updated 8/21/2024</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>
    </div>
    <div class="presentations">
      <h4>Student Journals</h4>
      <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
      <ul>
        <li><a href="https://docs.google.com/presentation/d/1QaDr0Sn94exVyXxYEZ4d7WXZZUFX7-sh1VJTQ_rRsCo/copy" target="_blank">3PNG Forces and Interactions (Second Edition) Student Journal</a></li>
        <li><a href="https://drive.google.com/file/d/1Bkpdjz2YrPUmJO7CC0B3dpPyNSC4H4Oz/view" target="_blank">3PNG Forces and Interactions (Second Edition) Student Journal Answer Key</a></li>
        <li><a href="https://docs.google.com/presentation/d/1tDBBWiAdg9I9CEcpQhyG-ZofrYgakZsbU7S-9bpmqZo/copy" target="_blank">3PNG Forces and Interactions (Second Edition) Student Journal - SPANISH</a></li>
      </ul>

    </div>
    <div class="presentations">
      <h4>Individual Resources</h4>
      <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/15qkxm_wrm4kQTGwTgEcVpejjfpeYMO5rd3MLkj63dPU/copy" target="_blank">What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1jCslUAcTLXx2SZGGCnQ-3AA0hciW_Zy5vFpv1kcdeuY/copy" target="_blank">Word Wall</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->

        </ul>
      <h4 style="margin-left: 10px;">Demonstration Videos</h4>
      <ul>
        <li><a href="https://drive.google.com/file/d/1oixhHdeNeHagtRWDHyI7xpGCPFnkzSXI/view?usp=sharing" target="_blank">Battery Investigation</a></li>
        <li><a href="https://drive.google.com/file/d/16Tl4821OvfxvjNk3tDQ6wGMXlAVqLQtb/view?usp=sharing" target="_blank">Cotton Ball Investigation</a></li>
        <li><a href="https://drive.google.com/file/d/1lMvuEGEUVp5n841SfnnrC9FAB7jjY3Y2/view?usp=sharing" target="_blank">Direction Investigation</a></li>
        <li><a href="https://drive.google.com/file/d/1UZyzw88ACECE0wWT8bhAb1-jEdqAID69/view?usp=sharing" target="_blank">Fire Truck Express Challenge</a></li>
        <li><a href="https://drive.google.com/file/d/1NEJY9D_L-OSHDNEjo8dAa5-Yhk8rmPoR/view?usp=sharing" target="_blank">Jumping Frog Investigation</a></li>
        <li><a href="https://drive.google.com/file/d/1enoGwBhA73UZZShZ2lJjZLzq2moTY1lU/view?usp=sharing" target="_blank">Speed Investigation</a></li>
        <li><a href="https://drive.google.com/file/d/1DAdhsz20ogSt8dzzKg_uOPzNdtLIEnAH/view?usp=sharing" target="_blank">Tire Tread Investigation</a></li>
        <li><a href="https://youtu.be/VRhijbgLm3k?t=188" target="_blank">Homemade Toy Car Video</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="css" scoped>
.presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
}
ul {
  list-style: none;
}
.presentations a {
  margin-left: 40px;
}
li {
  margin-left: -40px;
}
.back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
}
.back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
}
</style>
